import { useMutation, useQuery } from "@tanstack/react-query";
import { WorkLocationsAPI } from "../api";

export const useGetAllWorkLocations = () => {
  return useMutation({
    mutationFn: () => WorkLocationsAPI.getAll(),
    onError: (error) => {
      console.error("Get All Work Locations Failed: ", error.response || error);
    },
  });
};

export const useGetAllWorkLocationsPaginated = ({
  page,
  pageSize,
  filterField1 = null,
  filterValue1 = null,
  filterField2 = null,
  filterValue2 = null,
}) => {
  return useQuery({
    queryKey: [
      "get-all-work-locations",
      page,
      pageSize,
      filterField1,
      filterValue1,
      filterField2,
      filterValue2,
    ],
    queryFn: () => {
      const obj = { page, pageSize };

      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }

      return WorkLocationsAPI.getAllPaginated(obj);
    },
    onError: (error) => {
      console.error("Get All Work Locations Failed: ", error.response || error);
    },
  });
};

export const useGetWorkLocationById = (id) => {
  return useQuery({
    queryKey: ["get-work-locations-by-id", id],
    queryFn: () => WorkLocationsAPI.getById(id),
    enabled: !!id,
    onError: (error) => {
      console.error(
        "Get Work Location By ID Failed: ",
        error.response || error
      );
    },
  });
};

export const useCreateWorkLocation = () => {
  return useMutation({
    mutationFn: (payload) => WorkLocationsAPI.create(payload),
    onError: (error) => {
      console.error("Create Work Location Failed: ", error.response || error);
    },
  });
};

export const useUpdateWorkLocation = () => {
  return useMutation({
    mutationFn: ({ id, payload }) => WorkLocationsAPI.update({ id, payload }),
    onError: (error) => {
      console.error("Update Work Location Failed: ", error.response || error);
    },
  });
};

export const useDeleteWorkLocation = () => {
  return useMutation({
    mutationFn: (id) => WorkLocationsAPI.delete(id),
    onError: (error) => {
      console.error("Delete Work Location Failed: ", error.response || error);
    },
  });
};
